import { render, staticRenderFns } from "./VoiceDemoCard.vue?vue&type=template&id=6fe6a98f&scoped=true&"
import script from "./VoiceDemoCard.vue?vue&type=script&lang=js&"
export * from "./VoiceDemoCard.vue?vue&type=script&lang=js&"
import style0 from "./VoiceDemoCard.vue?vue&type=style&index=0&id=6fe6a98f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe6a98f",
  null
  
)

export default component.exports